import { FunctionComponent } from 'react';
import classnames from 'classnames';

import { QuickViewButton } from '../../QuickViewButton';
import { MoreOptionsBadge } from '../../Badges/MoreOptions';
import styles from '../styles.scss';

type Props = {
    hideDivider?: boolean;
    showMoreOptionsBadge: boolean;
    showQuickView?: boolean;
    openQuickView?: () => void;
    showQuickViewIcon?: boolean;
    dimensions?: string;
    pdpUrl: string;
};

export const ProductDetails: FunctionComponent<Props> = ({
    hideDivider,
    showMoreOptionsBadge,
    showQuickView,
    openQuickView,
    showQuickViewIcon,
    dimensions,
    pdpUrl,
}: Props) => (
    <div
        className={classnames(styles.productDetailWrapper, {
            [styles.hideDivider]: hideDivider,
        })}
    >
        {showMoreOptionsBadge && <MoreOptionsBadge localizedPdpUrl={pdpUrl} />}
        {showQuickView && (
            <QuickViewButton
                openQuickView={openQuickView}
                showQuickViewIcon={showQuickViewIcon}
                hideDivider={hideDivider}
            />
        )}
        {!!dimensions && (
            <div className={styles.dimensions} data-tn="dimensions">
                {dimensions}
            </div>
        )}
    </div>
);
